import { EventEmitter } from 'events';
import * as Inovx from '@shared';
import UserConstants from '../constants/UserConstants';
import UserServices from '../services/UserServices';
import AuthenticationModeEnum from '../constants/AuthenticationModeEnum';
var CommonMessages = Inovx.Shared.Common.CommonMessages;

declare var InovxLoader: any;

var CHANGE_EVENT = 'user.change';
var _users: IUser[] = [],
    _hints: IUser[] = [],
    _editUser: IUserDetails | any = getBlankUser(),
    _currentUser: IUserDetails = null,
    _settings: IUserAppSetting = getBlankUserAppSetting(),
    _editSettings: IUserAppSetting | any = getBlankUserAppSetting(),
    _beginAdd = false,
    _beginEdit = false,
    _changesMade = false,
    _modalVisible = false,
    _settingsShown = false,
    _validation: IValidationStoreObject = {},
    _entitlements: IEntitlementGroup[] = [],
    _roles: IRole[] = [];

function loadUserData(data: IUser[]) {
    _users = data;
}

function loadHints(data: IUser[]) {
    _hints = data;
}

function loadCurrentUser(data: IUserDetails) {
    _currentUser = data;
}

function showUserSettings(show: boolean) {
    _settingsShown = _modalVisible = show;
    _changesMade = false;
    _initalizeValidation(UserConstants.USER_SETTINGS_FORM);
}

function setAddingUser() {
    _beginAdd = _modalVisible = true;
    _beginEdit = false;
    _changesMade = false;
    _editUser = getBlankUser();
    _initalizeValidation(UserConstants.USER_ADD_FORM);

}

function setEditingUser(user: IUserDetails) {
    _modalVisible = _beginEdit = true;
    _beginAdd = false;
    _changesMade = false;
    _editUser = user;
    _initalizeValidation(UserConstants.USER_ADD_FORM);
}

function _updateObjectListProp(comp: string, key: string, value: any, add: boolean) {
    switch (comp) {
        case UserConstants.USER_ADD_FORM:
            _updateUserListChanges(key, value, add);
            _changesMade = true;
            break;
    }
}

function _updateUserListChanges(name: string, value: string, add: boolean) {
    switch (name) {
        default:
            if (Array.isArray(_editUser[name])) {
                if (add) {
                    _editUser[name].push(value);
                } else {
                    let indx = _editUser[name].indexOf(value);
                    if (indx > -1) {
                        _editUser[name].splice(indx, 1);
                    }
                }
            }
            _setValidValidation(UserConstants.USER_ADD_FORM, name);
            break;
    }
}

function _updateObject(comp: string, key: string, value: any, fromUI: boolean = true) {
    switch (comp) {
        case UserConstants.USER_ADD_FORM:
            _updateUserChanges(key, value, fromUI);
            _changesMade = true;
            break;
        case UserConstants.USER_SETTINGS_FORM:
            _updateSettingChanges(key, value);
            _changesMade = true;
            break;
    }
}

function _updateUserChanges(name: string, value: string, fromUI: boolean) {
    var isNativeLoginMode: boolean= true;
    var isAzureADLoginMode: boolean = true;
    if (_settings) {
        if (_settings.AuthenticationMode == AuthenticationModeEnum.Mixed) {
            isNativeLoginMode = true;
            isAzureADLoginMode = true;
        } else if (_settings.AuthenticationMode == AuthenticationModeEnum.ExternalOnly) {
            isNativeLoginMode = false;
            isAzureADLoginMode = true;
        } else if (_settings.AuthenticationMode == AuthenticationModeEnum.LocalOnly) {
            isNativeLoginMode = true;
            isAzureADLoginMode = false;
        }
    }

    switch (name) {
        case "Email":
            var Email = "Email";
            _editUser[Email] = value;
            if (value) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(value)) {
                    _validation[UserConstants.USER_ADD_FORM][Email].invalidValueMessage = InovxLoader.t("users:form.invalidEmail");
                    _validation[UserConstants.USER_ADD_FORM][Email].invalidValue = true;
                }else if (_users.filter(function (user) { return user.Email && user.Email.toLowerCase() === value.toLowerCase() && user.UserID !== _editUser.UserID }).length > 0) {
                    _validation[UserConstants.USER_ADD_FORM][Email].invalidValueMessage = InovxLoader.t("users:form.duplicateEmail");
                    _validation[UserConstants.USER_ADD_FORM][Email].invalidValue = true;
                } else {
                    _setValidValidation(UserConstants.USER_ADD_FORM, Email);
                }
            } else {
                _validation[UserConstants.USER_ADD_FORM][Email].invalidValueMessage = CommonMessages.Validation.Required;
                _validation[UserConstants.USER_ADD_FORM][Email].invalidValue = true;
            }
            break;
        case "Password":
        case "VPass":
            var VPass = "Password";
            _editUser[VPass] = value;
            if (isNativeLoginMode) {
                if (_beginEdit || value) {
                    _setValidValidation(UserConstants.USER_ADD_FORM, VPass);
                } else {
                    _validation[UserConstants.USER_ADD_FORM][VPass].invalidValueMessage = CommonMessages.Validation.Required;
                    _validation[UserConstants.USER_ADD_FORM][VPass].invalidValue = true;
                }
            } else {
                _setValidValidation(UserConstants.USER_ADD_FORM, VPass);
            }
            break;
        case "ExternalAccountUserName":
            _editUser[name] = value;
            if (isAzureADLoginMode && !isNativeLoginMode) {
                if (value) {
                    if (value == null || value.length == 0) {
                        _validation[UserConstants.USER_ADD_FORM][name].invalidValueMessage = CommonMessages.Validation.Required;
                        _validation[UserConstants.USER_ADD_FORM][name].invalidValue = true;
                    }
                    else {
                        _setValidValidation(UserConstants.USER_ADD_FORM, name);
                    }
                }
                else {
                    _validation[UserConstants.USER_ADD_FORM][name].invalidValueMessage = CommonMessages.Validation.Required;
                    _validation[UserConstants.USER_ADD_FORM][name].invalidValue = true;
                }
            } else {
                _setValidValidation(UserConstants.USER_ADD_FORM, name);
            }

            break;
        default:
            if (name != 'UserID' && name != 'UserVersionToken') {
                _editUser[name] = value;
            }
            _setValidValidation(UserConstants.USER_ADD_FORM, name);
            break;
    }
}

function _updateSettingChanges(name: string, value: string) {
    _editSettings[name] = value;

    switch (name) {
        case "PasswordExpiration":
            if (_editSettings["PasswordExpires"] && !_isValidIntegerBetweenRange(value, 14, 730)) {
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValue = true;
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValueMessage = InovxLoader.t("users:settingsForm.numberValue", { min: 14, max: 730 });
            } else {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
            }
            break;
        case "PasswordExpires":
            if (!value) {
                _editSettings[name] = false;
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, "PasswordExpiration");
            }
            break;
        case "AllowedAttempts":
            if (!_isValidIntegerBetweenRange(value, 1, 5)) {
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValue = true;
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValueMessage = InovxLoader.t("users:settingsForm.numberValue", { min: 1, max: 5 });
            } else {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
            }
            break;
        case "PasswordCharacters":
            if (!_isValidIntegerBetweenRange(value, 1, 32)) {
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValue = true;
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValueMessage = InovxLoader.t("users:settingsForm.numberValue", { min: 1, max: 32 });
            } else {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
                _updateSettingChanges("PasswordNumbers", _editSettings["PasswordNumbers"]);
                _updateSettingChanges("PasswordSymbols", _editSettings["PasswordSymbols"]);
            }
            break;
        case "PasswordSymbols":
            var numberOfCharacters = _editSettings["PasswordCharacters"];
            var numberOfDigits = _editSettings["PasswordNumbers"];
            if (!_isValidIntegerBetweenRange(value, 0, numberOfCharacters - numberOfDigits)) {
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValue = true;
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValueMessage = InovxLoader.t("users:settingsForm.invalidDigitsOrSymbols");
            } else {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, "PasswordNumbers");
            }
            break;
        case "PasswordNumbers":
            var numberOfCharacters = _editSettings["PasswordCharacters"];
            var numberOfSymbols = _editSettings["PasswordSymbols"];
            if (!_isValidIntegerBetweenRange(value, 0, numberOfCharacters - numberOfSymbols)) {
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValue = true;
                _validation[UserConstants.USER_SETTINGS_FORM][name].invalidValueMessage = InovxLoader.t("users:settingsForm.invalidDigitsOrSymbols");
            } else {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, "PasswordSymbols");
            }
            break;
        default:
            _setValidValidation(UserConstants.USER_SETTINGS_FORM, name);
            break;
    }
}

function _isValidIntegerBetweenRange(value: string, min: number, max: number) {
    var parsedValue = Number(value);
    if (!isNaN(parsedValue) && parsedValue % 1 === 0 && parsedValue >= min && parsedValue <= max) {
        return true;
    }
    return false;
}

function _setValidValidation(comp: string, name: string) {
    if (_validation[comp][name]) {
        _validation[comp][name].invalidInput = false;
        _validation[comp][name].invalidValue = false;
    } else {
        _validation[comp][name] = _getNewValidationObject();
    }
}

function _getNewValidationObject() {
    return {
        invalidInput: false,
        invalidValue: false
    } as IValidationObject;
}

function _validate(comp: string) {
    switch (comp) {
        case UserConstants.USER_ADD_FORM:
            _ensureValidObject(comp, _editUser);
            return _validateObject(UserConstants.USER_ADD_FORM);
        case UserConstants.USER_SETTINGS_FORM:
            _ensureValidObject(comp, _editSettings);
            return _validateObject(UserConstants.USER_SETTINGS_FORM);
    }
    return false;
}

function _ensureValidObject(comp: string, obj: any) {
    var updateChangesFunct = (name: string, value: string, fromUI: boolean) => { };
    var updateListChangesFunct = (name: string, value: string) => { };
    switch (comp) {
        case UserConstants.USER_ADD_FORM:
            updateChangesFunct = _updateUserChanges;
            break;
        case UserConstants.USER_SETTINGS_FORM:
            updateChangesFunct = _updateSettingChanges;
            break;
    }

    for (var k in obj) {
        var objType = typeof (obj[k]);
        if (objType !== 'function') {
            if (obj[k] === null || objType !== 'object' || Array.isArray(obj[k])) {
                updateChangesFunct(k, obj[k], false);
            } else {
                _ensureValidObject(comp, obj[k]);
            }
        }
    }
}

function _validateObject(comp: string) {
    var ret = true;

    for (var k in _validation[comp]) {
        if (_validation[comp][k].invalidValue) {
            return false;
        }
    }

    return ret;
}

function _initalizeValidation(comp: string) {
    switch (comp) {
        case UserConstants.USER_ADD_FORM:

            var valiObj: IValidationDictionaryObject = _validation[UserConstants.USER_ADD_FORM] = {};

            for (var k in _editUser) {
                _setValidValidation(UserConstants.USER_ADD_FORM, k);
            }
            break;

        case UserConstants.USER_SETTINGS_FORM:

            valiObj = _validation[UserConstants.USER_SETTINGS_FORM] = {};

            for (var k in _settings) {
                _setValidValidation(UserConstants.USER_SETTINGS_FORM, k);

                valiObj[k].invalidValueMessage = CommonMessages.Validation.PositiveInteger;
            }

            break;
    }
}

function validationError(comp: string, messageObj: IErrorMessageObject) {
    _validation[comp][messageObj.propertyName].invalidValueMessage = messageObj.message;
    _validation[comp][messageObj.propertyName].invalidValue = true;
}

function finishedEditing() {
    _modalVisible = false;
    _changesMade = false;
}

function selectHint(user: IUser) {
    _updateProfile(user);
    _updateUserChanges("ExternalAccountUserName", user.UserName, true);
    _updateUserChanges("Email", user.Email, true);
}

function _updateProfile(user: IUser) {
    _editUser["FirstName"] = user.FirstName;
    _editUser["LastName"] = user.LastName;
    _editUser["UserName"] = user.UserName;
    _editUser["ExternalAccountUserName"] = user.UserName;
    _editUser["ExternalAccountID"] = user.UserID;
}

function getBlankUser(): IUserDetails {
    return {
        UserID: "", UserVersionToken: null, Enabled: true, FirstName: "", LastName: "", UserName: "",
        Password: "", Email: "", ExternalAccountUserName: "", ExternalAccountID: "", PasswordExpired: false, MaxLoginAttempts: false,
        EntitlementGroupIDs: [], RoleIDs: []
    };
}

function getBlankUserAppSetting(): IUserAppSetting {
    return { PasswordExpiration: 0, AllowedAttempts: 0, PasswordCharacters: 0, PasswordSymbols: 0, PasswordNumbers: 0, RememberMe: false, AuthenticationMode: "", ExternalProviderName: "" };
}

function sortINamedItem(a: IDefaultNamedItem, b: IDefaultNamedItem) {
    if (!a) return -1;
    if (!b) return 1;
    return (a.Name > b.Name) ? 1 : (b.Name > a.Name) ? -1 : 0;
}

var UserStore: IUserStore = Object.assign({}, EventEmitter.prototype, {
    getAll: function () {
        return _users;
    },
    getEditUser: function () {
        return _editUser;
    },

    getEditUserCopy: function () {
        var user = { ..._editUser };
        user.EntitlementGroupIDs = user.EntitlementGroupIDs.slice();
        user.RoleIDs = user.RoleIDs.slice();
        return user;
    },

    getCurrentUser: function () {
        return _currentUser;
    },

    getHasChanges: function () {
        return _changesMade;
    },
    getIsAdding: function () {
        return _beginAdd;
    },
    getIsEditing: function () {
        return _beginEdit;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    getSettingsShown: function () {
        return _settingsShown;
    },
    getSettings: function () {
        return _settings;
    },
    getEditSettings: function () {
        return _editSettings;
    },
    getSaveFriendlyEditSettings: function () {
        var edit: IUserAppSetting = { ..._editSettings };
        edit.AllowedAttempts = parseInt(_editSettings.AllowedAttempts);
        edit.PasswordCharacters = parseInt(_editSettings.PasswordCharacters);
        edit.PasswordExpiration = parseInt(_editSettings.PasswordExpiration);
        edit.PasswordNumbers = parseInt(_editSettings.PasswordNumbers);
        edit.PasswordSymbols = parseInt(_editSettings.PasswordSymbols);
        return edit;
    },

    checkUser: function () {
        return _hints;
    },
    updateExternalAccountID: function (id: string) {
        _editUser.ExternalAccountID = id;
    },
    getValidation(key: string) {
        return _validation[key];
    },
    getIsValidObject(key: string) {
        return _validate(key);
    },
    getValidRoles() {
        return _roles;
    },
    getValidEntitlements() {
        return _entitlements;
    },
    emitChange: function () {
        return this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload:any) {
    switch (payload.actionType) {
        case UserConstants.BEGIN_USER_ADD:
            setAddingUser();
            _entitlements = payload.entitlement.sort(sortINamedItem);
            _roles = payload.role.sort(sortINamedItem);
            _editUser.EntitlementGroupIDs = _entitlements.filter((item) => {
                return item.IsDefault;
            }).map(item => item.ID);
            _editUser.RoleIDs = _roles.filter((item) => {
                return item.IsDefault;
            }).map(item => item.ID);
            break;
        case UserConstants.BEGIN_EDIT_USER:
            setEditingUser(payload.user);
            _entitlements = payload.entitlement.sort(sortINamedItem);
            _roles = payload.role.sort(sortINamedItem);
            _editUser.EntitlementGroupIDs.sort((a: string, b: string) => {
                let itemA: IEntitlementGroup = null;
                let itemB: IEntitlementGroup = null;
                for (let indx in _entitlements) {
                    if (_entitlements[indx].ID === a) {
                        itemA = _entitlements[indx];
                    } else if (_entitlements[indx].ID === b) {
                        itemB = _entitlements[indx];
                    }
                }
                return sortINamedItem(itemA, itemB);
            });
            _editUser.RoleIDs.sort((a: string, b: string) => {
                let itemA: IRole = null;
                let itemB: IRole = null;
                for (let indx in _roles) {
                    if (_roles[indx].ID === a) {
                        itemA = _roles[indx];
                    } else if (_roles[indx].ID === b) {
                        itemB = _roles[indx];
                    }
                }
                return sortINamedItem(itemA, itemB);
            });
            break;
        case UserConstants.FINISH_EDIT:
            finishedEditing();
            break;
        case UserConstants.USER_RECIEVE_DATA:
            loadUserData(payload.data);
            break;
        case UserConstants.USER_RECIEVE_HINT:
            loadHints(payload.data);
            payload.callback();
            return true;
        case UserConstants.USER_UPDATE_OBJECT:
            _updateObject(payload.component, payload.key, payload.value);
            break;
        case UserConstants.USER_UPDATE_OBJECT_ADD_LIST:
            _updateObjectListProp(payload.component, payload.key, payload.value, true);
            break;
        case UserConstants.USER_UPDATE_OBJECT_REMOVE_LIST:
            _updateObjectListProp(payload.component, payload.key, payload.value, false);
            break;
        case UserConstants.USER_SELECT_HINT:
            selectHint(payload.user);
            break;
        case UserConstants.USER_FORM_INVALID_SAVE:
            break;
        case UserConstants.HIDE_SETTINGS_MENU:
            showUserSettings(false);
            break;
        case UserConstants.SETTINGS_GET:
            _settings = payload.data;
            _editSettings = { ..._settings };
            _editSettings.PasswordExpires = _settings.PasswordExpiration > 0;
            showUserSettings(payload.display);
            break;
        case UserConstants.USER_RECIEVE_CURRENT:
            loadCurrentUser(payload.data);
            payload.callback();
            return true;
        case UserConstants.USER_VALIDATION_ERROR:
            validationError(payload.component, payload.messageObj);
            break;
        case UserConstants.USER_CHANGE_PASSWORD_SUCCESS:
            _editUser.PasswordExpired = false;
            _editUser.UserVersionToken = payload.user.UserVersionToken;
            break;
        case UserConstants.RESET_LOGIN_ATTEMPTS:
            _editUser.MaxLoginAttempts = payload.user.MaxLoginAttempts;
            _editUser.UserVersionToken = payload.user.UserVersionToken;
            break;
        default: return true;
    }

    UserStore.emitChange();

    return true;
});

export default UserStore;
